<template>
  <div style="width: 100%;height: 100%;" class="body2">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="convenientIndex"></headers>
          <div class="position">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a  href="javascript:void(0)" @click="urlTo('convenientIndex')">便民查询</a>/<span>{{title}}查询</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">
          <div >

            <div style="padding-bottom: 20px">
            </div>
          </div>

          <div class="clear"  style="padding-bottom: 30px"></div>
          <span style="color: white;">区划：
          <el-cascader @change="search()" v-model="selectedRegion" :props="props" :show-all-levels="false"   clearable placeholder="请选择区划" style="width: 180px;margin-right: 10px;"/>
            <!--<el-cascader :options="departOption" v-model="selecteddepartOption" clearable  placeholder="办事单位" style="width: 180px;display: none"></el-cascader>-->
          </span>

          <!--    <span style="padding-left: 30px;padding-right: 20px"  >办事网点名称：
                 <el-input   maxlength="18"
                             style="width: 250px" placeholder="请输入办事网点名称" v-model="pubName"  clearable class="input-with-select">
              </el-input>

              </span>-->
          <!--     <el-button  @click="search" type="primary" icon="el-icon-search">查询</el-button>
 -->
          <span  style="color: white;"> 名称：<el-input v-model="pubName" placeholder="请输入网点名称" clearable style="width: 180px;"></el-input></span>
          <!--              <span style="margin-left: 15px;"> 姓名：<el-input v-model="pname" placeholder="请输入姓名" clearable style="width: 180px;"></el-input></span>-->
          <span style="padding-left: 15px;"><el-button type="danger" @click="search()" icon="el-icon-search">搜索</el-button></span>
          <div style="padding-bottom: 50px"></div>

          <div class="aaa" style="padding-top: 40px;">
            <template>
              <el-table

                :data="dataObjList"
                border
                style="width: 100%">
                <el-table-column
                  align="center"
                  prop="party"
                  label="所属区划"
                  width="180">
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="ciName"
                  label="名称"
                  width="180">
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="tel"
                  width="200px"
                  label="联系电话">
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="workAddress"
                  label="办公地址">
                </el-table-column>


                <el-table-column
                  align="center"
                  width="100"
                  prop="address"
                  label="操作">
                  <template slot-scope="scope" >
                    <el-button
                      @click.native.prevent="seeShare('communitySearchDetail',{detail_id:scope.row.ciId,title:title,code:communityType})"
                      type="text"
                      size="small">
                      详情信息
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
            <div v-if="dataObjList.length>0 && dataObjList" style="text-align: center;padding-top: 30px" class="block">
              <el-pagination
                layout="prev, pager, next"
                :total="total" :page-size="pageSize" @current-change="pageZjChange" @prev-click="prevZjClick" @next-click="nextZjClieck">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  export default {
    name: "public-index",
    components:{
      headers,fixedDiv,footers
    },
    data() {
      let _self=this;
      return {
        zjPageNum:1,
        archType:'',
        zjTypeData:'',
        title:'',
        personType:'',
        dylbOption:"",
        options:"",
        pubCode:"",
        socialType:"",
        active: 'publicIndex',
        width:document.body.clientWidth+'px',
        height:document.body.clientHeight+'px',
        props: {
          lazy: true,
          checkStrictly:true,
          lazyLoad (node, resolve) { const { level } = node;
            var t=0;
            if(!node.value){
              node.value=_self.$cookies.get("areaRoot");
              t=1;
              //上级为空，默认设置大通县数据
            }
            const options={pid:node.value}
            _self.$https.post("api/pu/getAreaByParentCode.do",options,response=>{
              const nodes =[];
              // if(t==0) {
                if (response.status === 200 && response.data.code === 200) {
                  const nodes = Object.values(response.data.data).map(function (e) {
                    return {label: e.name, value: e.code, level: 0, leaf: level >= 3}
                  })
                  resolve(nodes);
                } else {
                  resolve(nodes);
                }
              // }else{
              //   const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
              //   resolve(nodes);
              // }
            })
          }
        },
        treeData:[],
        defaultProps: {
          children: 'children',
          label: 'text'
        },
        listData:[],
        searchTitle:'',
        orgTypeCode:'',
        pageNum:1,
        pageSize:10,
        knowListData:[],
        tableData:[],
        knowListTotal:0,
        selectedRegion:[],
        dataObjList:[],
        selecteddepartOption:[],
        departOption:[],
        listDataType:[],
        listDataZj:[],
        typeList:[],
        archList:[],
        SocialStateList:[],
        personList:[],
        selecteddylbOption:[],
        qry_archive_type:'',
        qry_policy_type:'',
        qry_policy_grade:'',
        pubName:'',
        knowName:'',
        communityType:'',
        pageTotal:0,
        orgStateCode:"",
        total:0,
        activeName: 'first',

        knowType:'',


      }
    } ,
    watch: {
      width(n,o){
        alert(n+'w')
      },
      height(n,o){
        alert(n+'h')
      },
      // selectedRegion(nv){
      //   this.getDepartAreas(nv[nv.length-1],0);
      // }
    },
    created(){
      this.title = this.$route.query.name;
        this.getTypeList();

    },
    methods: {
      gotoDetail(detail_id){
        this.$router.push({path:'PolicyDetail',query:{detail_id:detail_id}})
      },


      getTypeList() {
        // 异步更新数据
        var _wdid='';
        if(this.selectedRegion && this.selectedRegion.length>0){
          _wdid=this.selectedRegion[this.selectedRegion.length-1];
        }
        const options={
          workDepartId:_wdid,
          pubName:this.pubName,
          pageNum:this.pageNum,
          pageSize:this.pageSize,
          type:'web',
        };
        var t=this;
        this.$https.post("api/community/getCommunityService.do",options,response=>{
          if (response.status === 200 && response.data.code===200 && response.data.data) {
            if(response.data.data.dataList && response.data.data.dataList.length>0){
              t.dataObjList=response.data.data.dataList;
              t.total=response.data.data.total;
            }
          }
        })
      },


      prevZjClick(a){
        this.pageNum=this.pageNum-1;
        this.getTypeList();
      },
      nextZjClieck(a){
        this.pageNum=this.pageNum+1;
        this.getTypeList();
      },

      pageZjChange(a){
        this.pageNum=a

        this.getTypeList(a);
      },



      search(){
        this.pageNum=1;
        this.dataObjList=[];
        if (this.orgStateCode.length>0 ){
          this.orgStateCode=this.orgStateCode[0];
        }else {
          this.orgStateCode=""
        }
        this.getTypeList();
      },

      handleNodeClick(data){
        if(data.children && data.children.length>0){
          this.qry_archive_type = '';
          this.qry_policy_type = '';
          this.qry_policy_grade =  '';
          console.log(data);
          return;
        }
        if(data.attributes.type=='qry_archive_type'){
          if(this.qry_archive_type !=data.id){
            this.qry_archive_type=data.id;
            this.qry_policy_type='';
            this.qry_policy_grade='';
            this.initData(1);
            console.log(data);
          }
        }else if(data.attributes.type=='qry_policy_type'){
          if(this.qry_policy_type !=data.id) {
            this.qry_archive_type = '';
            this.qry_policy_type = data.id;
            this.qry_policy_grade = '';
            this.initData(1);
            console.log(data);
          }
        }else if(data.attributes.type=='qry_policy_grade'){
          if(this.qry_policy_grade !=data.id) {
            this.qry_archive_type = '';
            this.qry_policy_type = '';
            this.qry_policy_grade =  data.id;
            this.initData(1);
            console.log(data);
          }
        }else{
          this.qry_archive_type = '';
          this.qry_policy_type = '';
          this.qry_policy_grade =  '';
          this.initData(1);
          console.log(data);
        }
      },
      initRootTree(){
        this.$https.post("api/policy/getQryConditionTreeData.do",{},response=>{
          if (response.status === 200 && response.data.code===200) {
            this.treeData=response.data.data;
          } else {
          }
        })
      },

      seeShare(url,d){
        let routeUrl = this.$router.resolve({
          path: "/"+url,
          query: d
        });
        window.open(routeUrl.href, '_blank');
      },
      getDepartAreas(ParentId,index){
        const options={pid:ParentId}
        var t=this;
        this.$https.post("api/pu/getPartyByParentAreaCode.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            t.departOption = Object.values(response.data.data).map(function(e){
              return {label:e.name,value:e.code,leaf:true}
            })
          } else {
            t.departOption =[];
          }
        })
      },
      getKnowContent(id){

        this.$router.push({path:'KnowDetail',query:{detail_id:id,name:this.knowName}})

        /* this.$https.post("api/policy/getKnowledgeDeta.do",{id},response=>{
           if (response.status === 200 && response.data.code===200) {

           } else {
           }
         })*/

      },
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      }
    }
  }



</script>
<style>
  .publicity table td {
    padding: 0px 5px;
  }
  .policy_left2 .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: #3f76ea;
    color: white;
  }

</style>



// WEBPACK FOOTER //
// src/pages/search/CommunitySearch.vue